import { FC, useState } from 'react';

import AboutThree from './components/AboutThree';

type IProductProps = object;

const Product: FC<IProductProps> = () => {
  return (
    <div className='mt-10'>
      <AboutThree />
    </div>
  );
};

export default Product;
